<template>
  <div>
    <a-modal
      :width="900"
      v-model="seeVisible"
      cancelText="false"
      @ok="visible = false"
    >
      <template slot="title">
        <div style="display:flex; align-items: center;">
          <icon-font type="gb-icon-gonggao" style="margin-right: 3px; font-size: 20px; line-height: 0"></icon-font>
          <span v-ucstr="$t('common_home_announcement', [$t('common_conj_system')])"></span>
        </div>
      </template>
      <tips style="margin: 0 -24px; border-top:none; border-radius: 0" v-if="announcementList.length">
        <span style="margin-right:30px;">
          <icon-font type="gb-icon-voice-o" ></icon-font>
          <span v-ucstr="$t('common_home_announcement', ['', $t('common_conj_type')])"></span>
          ：{{newsType[announcementList[announcementIndex].announcementType]}}
        </span>
        <span>
          <icon-font type="gb-icon-shijian"  ></icon-font>
          <span>{{$t('common_conj_time')}}：{{moment(announcementList[announcementIndex].announcementOnTime).format('YYYY-MM-DD HH:mm')}}</span>
        </span>
      </tips>
      <div class="information" ref="information" v-if="announcementList.length">
        <!-- 内容 -->
        <div class="information-box-conter">
          <div class="information-box-conter_loading" v-if="isLoading">
            <a-spin ></a-spin>
          </div>
          <div v-if="!isLoading">
            <div class="information-box-conter_title">{{announcementList[announcementIndex].announcementTitle}}</div>
            <div class="mce-content-body"
              style="padding: 0;"
              v-loaded="announcementList[announcementIndex].announcementContent"
              v-viewer.static="{movable: false}"
            ></div>
          </div>
        </div>
        <!-- 附件 -->
        <div class="information-box-conter" style="margin-top:27px;" v-if="announcementList[announcementIndex].enclosureList && announcementList[announcementIndex].enclosureList.length">
          <div class="information-box-conter_title">{{$t('common_btn_download_attachment')}}</div>
          <div class="detail-header-span iconfont-left" v-for="(item, index) in announcementList[announcementIndex].enclosureList" :key="index">
            <i class="iconfont gb-icon-wendang"></i>
            <span @click="enclosureClick(item.enclosureFileUrl, item.enclosureFileName)">{{item.enclosureFileName}}</span>
          </div>
        </div>
      </div>
      <template slot="footer">
        <!-- 下一条 -->
        <a-button style="height:32px;" :loading="isLoading" @click="nextClick" v-if="announcementIndex < announcementList.length - 1" >
          {{$t('common_btn_next_tiao', [$t('common_home_announcement', [])])}}
        </a-button>
        <!-- 我知道了 -->
        <a-button style="height:32px;" @click="closeClick" v-else>
          {{$t('common_btn_i_know')}}
        </a-button>
        <!-- 了解更多 -->
        <a-button type="primary" style="height:32px;" @click="informationClick">
          {{$t('common_btn_know_more')}}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { GetAnnouncementYhEjectDetail, DownloadImg } from '@/api/index'
import { downloadFn } from '@/utils/util.js'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import NoticeTips from './NoticeTips'
import richText from '@/mixins/richText-mixin'
import moment from 'moment'
export default {
  mixins: [richText],
  data () {
    const newsType = {
      1: this.$t('common_home_announcement_type1'),
      2: this.$t('common_home_announcement_type2'),
      // 3: this.$t('common_home_announcement_type3'),
      4: this.$t('common_home_announcement_type4'),
      5: this.$t('common_home_announcement_type5')
    }
    return {
      // shwoInformation: true,
      announcementList: {},
      announcementIndex: 0,
      newsType,
      seeVisible: false,
      scroller: null,
      isLoading: true
    }
  },
  computed: {
    ...mapGetters([
      'systemCode'
    ])
  },
  components: {
    tips: NoticeTips
  },
  methods: {
    moment,
    informationClick () {
      window.open('/#/company/notice/announcement?token=' + this.$ls.get(ACCESS_TOKEN))
      this.seeVisible = false
    },
    _GetAnnouncementYhDetail () {
      let params = {
        ejectFlag: 2,
        ejectPlatformType: 2,
        ejectSystemCode: this.systemCode
      }
      GetAnnouncementYhEjectDetail(params)
        .then(res => {
          const { data } = res
          this.announcementList = data || []
          // this.announcementList = Array.from({ length: 10 }).map((item, index) => ({
          //   'announcementId': 131 + index,
          //   'announcementTitle': 'cessss1cessss1cessss1',
          //   'announcementOnTime': '2021-02-01T14:21:15.000+0800',
          //   'announcementType': 1,
          //   'announcementContent': '<p>cessss1cessss1ceswwwwwsss1</p>',
          //   'enclosureList': null
          // }))
          if (this.announcementList.length) {
            this.isLoading = false
            this.seeVisible = true
          }
        })
    },
    closeClick () {
      this.seeVisible = false
    },
    nextClick () {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
        this.announcementIndex += 1
      }, 350)
    },
    enclosureClick (url, name) {
      if (!url) return
      const urlParamsAry = url.split('/')
      const fName = (urlParamsAry && urlParamsAry.length) ? urlParamsAry[5].split('?')[0] : ''
      let suffix = '.jpg'
      if (fName) {
        suffix = fName.substring(fName.indexOf('.'), fName.length) // .jpg
      }
      const fileName = (urlParamsAry && urlParamsAry.length) ? `${urlParamsAry[3]}/${urlParamsAry[4]}/${fName}` : ''
      if (!fileName) {
        this.$message.error(this.$t('common_home_param_error_nont_download'))
      }
      const formData = new FormData()
      formData.append('token', this.$ls.get(ACCESS_TOKEN))
      formData.append('fileName', fileName)

      DownloadImg(formData)
        .then(res => {
          downloadFn(res, name + suffix)
        })
    }
  },
  mounted () {
    this._GetAnnouncementYhDetail()
  }
}
</script>

<style lang="less" scoped>
  .anticon {
    margin-right: 3px;
  }
  .information-box-header {
    height: 30px;
    font-size: 16px;
    line-height: 30px;
    font-weight: 400;
    color: #333333;
    border-bottom: 1px solid #ccc;
  }
  .information {
    overflow: auto;
    height: 550px;
    margin: 0 -20px 0 -24px;
  }
  .information-box-conter {
    padding: 0 14px 0 24px;
    &_title {
      padding: 11px 0;
      line-height: 25px;
      color: #333;
      font-size: 16px;
      font-weight: 700;
      margin: 0 15px 0 0px;
      text-indent: 10px;
      position: relative;
      &::before{
        content: '';
        display: block;
        background: #5794FD;
        width: 3px;
        height: 14px;
        position: absolute;
        top: 50%;
        margin-top: -7px;
      }
    }
    &_tips {
      font-weight: 400;
      color: #777777;
      margin: 20px 0 10px 0;
      line-height: 20px;
      display: flex;
    }
    &_loading {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 500px;
    }
  }
  .information-flooer {
    position: fixed;
    bottom: 0;
    width: 98%;
    height: 50px;
    line-height: 50px;
    text-align: right;
    border-top: 1px solid #ccc;
  }
.detail-header-span {
  font-size: 16px;
  line-height: 20px;
  margin: 17px 0 -9px 0;
  cursor: pointer;
  color: #1890ff;
  span {
    margin-left:11px;
  }
}
/deep/.ant-modal-body {
  padding: 0 24px;
}
</style>
